/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum PasteMode {
	ExactCopy,
	TemplateOriginal,
	TemplateCurrent,
}
